import { useEffect } from "react";
import Header from "../../components/Header/Header";
import s from "./VacancyDetails.module.scss";
import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import Footer from "../../components/Footer/Footer";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { useParams } from "react-router-dom";
import { getVacancyDetails } from "../../redux/ApplicationSlice";
import { useTranslation } from "react-i18next";

const VacancyDetails = ({ data }) => {
  const vacancy = useSelector((state) => state.application.vacancyDetails);
  const { width } = useWindowDimensions();
  const params = useParams();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.application.lang);
  const { t } = useTranslation();

  useEffect(() => {
    if (params.id) {
      dispatch(getVacancyDetails(params.id));
    }
  }, [params.id, lang]);

  console.log("lang", lang);

  const downloadFile = (type) => {
    if (type === "consultantsApplication" && params.id === "1") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No. 1 APPLICATION OF A CONSULTANT FOR ACCREDITATION.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "APPLICATION OF A CONSULTANT FOR ACCREDITATION.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const fileUrl =
          "/assets/appendix/Приложение № 1 ЗАЯВКА КОНСУЛЬТАНТА НА ПРОХОЖДЕНИЕ АККРЕДИТАЦИИ.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Заявление.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    if (type === "consultantsDocuments" && params.id === "1") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No. 1 LIST OF REQUIRED DOCUMENTS.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "LIST OF REQUIRED DOCUMENTS.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const fileUrl =
          "/assets/appendix/Приложение № 1СПИСОК НЕОБХОДИМЫХ ДОКУМЕНТОВ.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "СПИСОК НЕОБХОДИМЫХ ДОКУМЕНТОВ.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    if (type === "consultantsDeclaration" && params.id === "1") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No7 Anti-corruption declaration.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Anti-corruption declaration";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const fileUrl =
          "/assets/appendix/Приложение №7 Антикор декларация.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Антикор декларация";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    if (type === "appriserApplication" && params.id === "2") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix1 Application for independent appraisal.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Application for independent appraisal";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const fileUrl = "/assets/appendix/Приложение №2 Заявка.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Заявление.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    if (type === "appriserDeclaration" && params.id === "2") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No7 Appraisers Anti-corruption declaration.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Appraisers Anti-corruption declaration";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const fileUrl =
          "/assets/appendix/Приложение № 5 АНТИКОРРУПЦИОННАЯ ДЕКЛАРАЦИЯ.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Приложение № 5 АНТИКОРРУПЦИОННАЯ ДЕКЛАРАЦИЯ.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    if (type === "appriserCV" && params.id === "2") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix2_Independent_appraisal_questionairre.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Independent appraisal questionairre";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const fileUrl =
          "/assets/appendix/Приложение №3 АНКЕТА НЕЗАВИСИМОГО ОЦЕНЩИКА.docx";
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Приложение №3 АНКЕТА НЕЗАВИСИМОГО ОЦЕНЩИКА.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    if (type === "insuranceCompaniesApplication" && params.id === "5") {
      const fileUrl =
        "/assets/appendix/Приложение № 3 ЗАЯВКА НА УЧАСТИЕ В АККРЕДИТАЦИИ СТРАХОВЫХ КОМПАНИЙ.docx";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download =
        "Приложение №3 ЗАЯВКА НА УЧАСТИЕ В АККРЕДИТАЦИИ СТРАХОВЫХ КОМПАНИЙ.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (type === "insuranceCompaniesCV" && params.id === "5") {
      const fileUrl =
        "/assets/appendix/Приложение №4 АНКЕТА СТРАХОВОЙ КОМПАНИИ.docx";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "Приложение №4 АНКЕТА СТРАХОВОЙ КОМПАНИИ.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (type === "insuranceCompaniesDeclaration" && params.id === "5") {
      const fileUrl =
        "/assets/appendix/Приложение №6 антикорупционная декларация.docx";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "Приложение №6 антикорупционная декларация.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const openFileInNewWindow = (e, type) => {
    e.preventDefault();
    if (type === "consultantsApplication" && params.id === "1") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No. 1 APPLICATION OF A CONSULTANT FOR ACCREDITATION.docx";
        window.open(fileUrl, "_blank");
      } else {
        const fileUrl =
          "/assets/appendix/Приложение № 1 ЗАЯВКА КОНСУЛЬТАНТА НА ПРОХОЖДЕНИЕ АККРЕДИТАЦИИ.docx";
        window.open(fileUrl, "_blank");
      }
    }
    if (type === "consultantsDocuments" && params.id === "1") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No. 1 LIST OF REQUIRED DOCUMENTS.docx";
        window.open(fileUrl, "_blank");
      } else {
        const fileUrl =
          "/assets/appendix/Приложение № 1СПИСОК НЕОБХОДИМЫХ ДОКУМЕНТОВ.docx";
        window.open(fileUrl, "_blank");
      }
    }

    if (type === "consultantsDeclaration" && params.id === "1") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No7 Anti-corruption declaration.docx";
        window.open(fileUrl, "_blank");
      } else {
        const fileUrl =
          "/assets/appendix/Приложение №7 Антикор декларация.docx";
        window.open(fileUrl, "_blank");
      }
    }

    if (type === "appriserApplication" && params.id === "2") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix1 Application for independent appraisal.docx";
        window.open(fileUrl, "_blank");
      } else {
        const fileUrl = "/assets/appendix/Приложение №2 Заявка.docx";
        window.open(fileUrl, "_blank");
      }
    }

    if (type === "appriserCV" && params.id === "2") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix2_Independent_appraisal_questionairre.docx";
        window.open(fileUrl, "_blank");
      } else {
        const fileUrl =
          "/assets/appendix/Приложение №3 АНКЕТА НЕЗАВИСИМОГО ОЦЕНЩИКА.docx";
        window.open(fileUrl, "_blank");
      }
    }
    if (type === "appriserDeclaration" && params.id === "2") {
      if (lang === "en") {
        const fileUrl =
          "/assets/appendix/Appendix No7 Appraisers Anti-corruption declaration.docx";
        window.open(fileUrl, "_blank");
      } else {
        const fileUrl =
          "/assets/appendix/Приложение № 5 АНТИКОРРУПЦИОННАЯ ДЕКЛАРАЦИЯ.docx";
        window.open(fileUrl, "_blank");
      }
    }

    if (type === "application" && params.id === "3") {
      const fileUrl =
        "/ЗАЯВКА КОНСУЛЬТАНТА НА ПРОХОЖДЕНИЕ АККРЕДИТАЦИИ ПО БИЗНЕС ПЛАНАМ .pdf";
      window.open(fileUrl, "_blank");
    }

    if (type === "insuranceCompaniesApplication" && params.id === "5") {
      const fileUrl =
        "/assets/appendix/Приложение № 3 ЗАЯВКА НА УЧАСТИЕ В АККРЕДИТАЦИИ СТРАХОВЫХ КОМПАНИЙ.docx";
      window.open(fileUrl, "_blank");
    }
    if (type === "insuranceCompaniesCV" && params.id === "5") {
      const fileUrl =
        "/assets/appendix/Приложение №4 АНКЕТА СТРАХОВОЙ КОМПАНИИ.docx";
      window.open(fileUrl, "_blank");
    }
    if (type === "insuranceCompaniesDeclaration" && params.id === "5") {
      const fileUrl =
        "/assets/appendix/Приложение №6 антикорупционная декларация.docx";
      window.open(fileUrl, "_blank");
    }
  };

  return (
    <div className={s.vacancy_details}>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <div className={s.category}>ВAКАНСИИ</div>
        <h2 className={s.h2}>{vacancy?.title}</h2>

        <div
          className={s.description}
          dangerouslySetInnerHTML={{ __html: vacancy?.description }}
        ></div>

        <div className={s.description}>
          <div
            className={s.subtitle}
            dangerouslySetInnerHTML={{ __html: vacancy?.details }}
          ></div>

          <div
            className={s.subtitle}
            dangerouslySetInnerHTML={{ __html: vacancy?.note }}
          ></div>
        </div>

        <div className={s.documents_btns}>
          <button className={s.title}>
            {params.id === "1" ? (
              <div className={s.appendix}>
                <div className={s.appendix_item}>
                  <div
                    className={s.file_name}
                    onClick={(e) =>
                      openFileInNewWindow(e, "consultantsApplication")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp;{" "}
                    {t("ЗАЯВКА КОНСУЛЬТАНТА НА ПРОХОЖДЕНИЕ АККРЕДИТАЦИИ")} 
                  </div>
                  <div
                    className={s.btn}
                    onClick={() => downloadFile("consultantsApplication")}
                  >
                    <DownloadOutlined />
                  </div>
                </div>
                <div className={s.appendix_item}>
                  <div
                    className={s.file_name}
                    onClick={(e) =>
                      openFileInNewWindow(e, "consultantsDocuments")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; {t("СПИСОК НЕОБХОДИМЫХ ДОКУМЕНТОВ")}
                  </div>
                  <div
                    className={s.btn}
                    onClick={() => downloadFile("consultantsDocuments")}
                  >
                    <DownloadOutlined />
                  </div>
                </div>
                <div className={s.appendix_item}>
                  <div
                    className={s.file_name}
                    onClick={(e) =>
                      openFileInNewWindow(e, "consultantsDeclaration")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; {t("АНТИКОРРУПЦИОННАЯ ДЕКЛАРАЦИЯ")}
                  </div>
                  <div
                    className={s.btn}
                    onClick={() => downloadFile("consultantsDeclaration")}
                  >
                    <DownloadOutlined />
                  </div>
                </div>
              </div>
            ) : params.id === "2" ? (
              <div className={s.appendix}>
                <div className={s.appendix_item}>
                  <div
                    className={s.file_name}
                    onClick={(e) =>
                      openFileInNewWindow(e, "appriserApplication")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; {t("ФОРМА ЗАЯВКИ НЕЗАВИСИМОГО ОЦЕНЩИКА")}
                  </div>
                  <div
                    className={s.btn}
                    onClick={() => downloadFile("appriserApplication")}
                  >
                    <DownloadOutlined />
                  </div>
                </div>
                <div className={s.appendix_item}>
                  <div onClick={(e) => openFileInNewWindow(e, "appriserCV")}>
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; {t("АНКЕТА НЕЗАВИСИМОГО ОЦЕНЩИКА")}
                  </div>
                  <div
                    className={s.btn}
                    onClick={() => downloadFile("appriserCV")}
                  >
                    <DownloadOutlined />
                  </div>
                </div>
                <div className={s.appendix_item}>
                  <div
                    onClick={(e) =>
                      openFileInNewWindow(e, "appriserDeclaration")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; {t("АНТИКОРРУПЦИОННАЯ ДЕКЛАРАЦИЯ")}
                  </div>
                  <div
                    className={s.btn}
                    onClick={() => downloadFile("appriserDeclaration")}
                  >
                    <DownloadOutlined />
                  </div>
                </div>
              </div>
            ) : params.id === "3" ? (
              "ЗАЯВКА КОНСУЛЬТАНТА НА ПРОХОЖДЕНИЕ АККРЕДИТАЦИИ ПО БИЗНЕС ПЛАНАМ"
            ) : params.id === "5" ? (
              <div className={s.appendix}>
                <div className={s.appendix_item}>
                  <div
                    className={s.file_name}
                    onClick={(e) =>
                      openFileInNewWindow(e, "insuranceCompaniesApplication")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; ЗАЯВКА СТРАХОВОЙ КОМПАНИИ НА ПРОХОЖДЕНИЕ АККРЕДИТАЦИИ
                  </div>
                  <div
                    className={s.btn}
                    onClick={() =>
                      downloadFile("insuranceCompaniesApplication")
                    }
                  >
                    <DownloadOutlined />
                  </div>
                </div>
                <div className={s.appendix_item}>
                  <div
                    className={s.file_name}
                    onClick={(e) =>
                      openFileInNewWindow(e, "insuranceCompaniesCV")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; АНКЕТА СТРАХОВОЙ КОМПАНИИ НА ПРОХОЖДЕНИЕ АККРЕДИТАЦИИ
                  </div>
                  <div
                    className={s.btn}
                    onClick={() => downloadFile("insuranceCompaniesCV")}
                  >
                    <DownloadOutlined />
                  </div>
                </div>
                <div className={s.appendix_item}>
                  <div
                    className={s.file_name}
                    onClick={(e) =>
                      openFileInNewWindow(e, "insuranceCompaniesDeclaration")
                    }
                  >
                    <FilePdfOutlined className={s.icon} />
                    &nbsp; {"Антикоррупционная декларация".toUpperCase()}
                  </div>
                  <div
                    className={s.btn}
                    onClick={() =>
                      downloadFile("insuranceCompaniesDeclaration")
                    }
                  >
                    <DownloadOutlined />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </button>
          {/* <div className={s.btn} onClick={() => downloadFile("application")}>
            <DownloadOutlined />
          </div> */}
        </div>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default VacancyDetails;
